// @flow
import { isEmpty } from "lodash";

const maxTimesSeen = 5;

export type onboardingComponentStatus = {
  component?: string,
  timesSeen: number,
  clicked: boolean
};

export type onboardingActivity = {
  lastActivityDate?: string,
  status: onboardingComponentStatus[]
};

const defaultOnboardingComponentStatus: onboardingComponentStatus = {
  timesSeen: 0,
  clicked: false
};

const defaultOnboardingActivity: onboardingActivity = {
  status: []
};

export const setOnboardingActivity = (
  components: string[],
  onboarding?: ?onboardingActivity
) => {
  const activity = onboarding || defaultOnboardingActivity;

  components.forEach((componentName) => {
    const foundKey = activity.status.find(
      (component) => component.component === componentName
    );

    if (!foundKey)
      activity.status = [
        ...activity.status,
        { component: componentName, ...defaultOnboardingComponentStatus }
      ];
  });

  activity.lastActivityDate = new Date().toUTCString();

  if (typeof window !== "undefined")
    window.localStorage.setItem("onboardingActivity", JSON.stringify(activity));
};

export const getOnboardingActivity = () => {
  // $FlowFixMe
  let activity;
  if (typeof window !== "undefined") {
    activity = window.localStorage.getItem("onboardingActivity");

    try {
      activity = JSON.parse(activity);
    } catch (err) {
      // $FlowFixMe
      activity = null;
    }
  }

  return activity;
};

export const setComponentStatus = (componentName: string, action: string) => {
  const activity = getOnboardingActivity();

  if (!isEmpty(activity)) {
    const componentOnboardingStatus: onboardingComponentStatus =
      activity.status.find(
        (componentStatus) => componentStatus.component === componentName
      );

    if (action === "click") componentOnboardingStatus.clicked = true;
    if (action === "seen") componentOnboardingStatus.timesSeen += 1;

    const newOnboardingComponentStatus = activity.status.map(
      (componentStatus) =>
        componentStatus.component === componentStatus
          ? componentOnboardingStatus
          : componentStatus
    );

    const newOnboardingActivity = {
      status: newOnboardingComponentStatus
    };

    setOnboardingActivity([componentName], newOnboardingActivity);
  }
};

export const daysSinceLastActivity = (lastActivityDate: string) => {
  const dateDifference =
    new Date().getTime() - new Date(lastActivityDate).getTime();
  return Math.floor(dateDifference / (1000 * 3600 * 24));
};

export const shouldShowOnboarding = (componentName: string): boolean => {
  const activity = getOnboardingActivity();

  if (!isEmpty(activity)) {
    // $FlowFixMe
    const dateDiff = daysSinceLastActivity(activity.lastActivityDate);
    const componentOnboardingStatus = activity.status.find(
      (componentStatus) => componentStatus.component === componentName
    );

    if (componentOnboardingStatus) {
      if (dateDiff >= 30) {
        setOnboardingActivity([componentName]); // reset times seen and click
        return true;
      }

      return (
        componentOnboardingStatus.timesSeen <= maxTimesSeen &&
        !componentOnboardingStatus.clicked
      );
    }
  }

  setOnboardingActivity([componentName], activity);
  return true;
};
